import {BaseColumn, BaseColumnConfig} from './base-column.model';

export class DateColumn extends BaseColumn {
  format: string;
  timeAgo: boolean;

  constructor(title,
              config: DateConfig) {
    super(title,
      {
        property: config.property,
      });
    this._columnType = 'DateColumn';
    this.format = config.format || 'yyyy/MM/dd';
    this.timeAgo = config.timeAgo || false;
  }

  get(element: any): any {
    return element[this.property];
  }
}

export interface DateConfig extends BaseColumnConfig {
  format?: string;
  timeAgo?: boolean;
}
